<div id="entity-selection" [formGroup]="form">
  <h3>Choose an entity type</h3>
  <mat-button-toggle-group [hideSingleSelectionIndicator]="true" formControlName="entityType" id="entity-selection-toggle" class="kyloe-entity-large entity-selection-toggle">
    @for (entity of entitiesToRender; track entity) {
      <mat-button-toggle
        value="{{entity.objectName}}" title="{{entity.label}}">
        <i class="{{getIcon(entity.objectName)}}"></i>
        <i class="{{getIcon(entity.objectName)}} watermark"></i>
        <span>
          {{ entity.label | uppercase }}
        </span>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>
